import { ExpenseCategory } from '../types/ExpenseCategory';

// Base expenses for Mexico City (cost of living index 45)
export const expenseCategories: ExpenseCategory[] = [
  {
    id: 'housing',
    name: 'Vivienda',
    icon: 'Home',
    items: [
      { 
        id: 'apartment-1br', 
        name: 'Apartamento de 1 habitación (centro)', 
        baseCost: 10848, 
        category: 'housing', 
        input_type: 'custom_amount', 
        default_value: 10848 
      },
      { 
        id: 'apartment-2br', 
        name: 'Apartamento de 2 habitaciones (centro)', 
        baseCost: 16272, 
        category: 'housing', 
        input_type: 'custom_amount', 
        default_value: 16272 
      },
      { 
        id: 'house-3br', 
        name: 'Casa de 3 habitaciones (suburbios)', 
        baseCost: 13560, 
        category: 'housing', 
        input_type: 'custom_amount', 
        default_value: 13560 
      },
      { 
        id: 'penthouse', 
        name: 'Penthouse de lujo (vistas panorámicas)', 
        baseCost: 31640, 
        category: 'housing', 
        input_type: 'custom_amount', 
        default_value: 31640 
      }
    ]
  },
  {
    id: 'transportation',
    name: 'Transporte',
    icon: 'Car',
    items: [
      { 
        id: 'public-transport', 
        name: 'Transporte público (pase mensual)', 
        baseCost: 1085, 
        category: 'transportation', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'compact-car', 
        name: 'Coche compacto (mantenimiento, seguro y combustible)', 
        baseCost: 4520, 
        category: 'transportation', 
        input_type: 'custom_amount', 
        default_value: 4520 
      },
      { 
        id: 'mid-suv', 
        name: 'SUV de gama media', 
        baseCost: 7232, 
        category: 'transportation', 
        input_type: 'custom_amount', 
        default_value: 7232 
      },
      { 
        id: 'luxury-car', 
        name: 'Coche de lujo', 
        baseCost: 13560, 
        category: 'transportation', 
        input_type: 'custom_amount', 
        default_value: 13560 
      }
    ]
  },
  {
    id: 'food',
    name: 'Alimentación',
    icon: 'Utensils',
    items: [
      { 
        id: 'basic-food', 
        name: 'Comida básica (en casa)', 
        baseCost: 3616, 
        category: 'food', 
        input_type: 'custom_amount', 
        default_value: 3616 
      },
      { 
        id: 'varied-food', 
        name: 'Comida variada (algunas comidas fuera)', 
        baseCost: 5424, 
        category: 'food', 
        input_type: 'custom_amount', 
        default_value: 5424 
      },
      { 
        id: 'quality-food', 
        name: 'Gastronomía de calidad (restaurantes frecuentes)', 
        baseCost: 9040, 
        category: 'food', 
        input_type: 'custom_amount', 
        default_value: 9040 
      },
      { 
        id: 'gourmet-food', 
        name: 'Experiencia gourmet (alta gastronomía)', 
        baseCost: 16272, 
        category: 'food', 
        input_type: 'custom_amount', 
        default_value: 16272 
      }
    ]
  },
  {
    id: 'entertainment',
    name: 'Entretenimiento',
    icon: 'Music',
    items: [
      { 
        id: 'basic-entertainment', 
        name: 'Entretenimiento básico', 
        baseCost: 1808, 
        category: 'entertainment', 
        input_type: 'custom_amount', 
        default_value: 1808 
      },
      { 
        id: 'regular-entertainment', 
        name: 'Entretenimiento regular', 
        baseCost: 3616, 
        category: 'entertainment', 
        input_type: 'custom_amount', 
        default_value: 3616 
      },
      { 
        id: 'premium-entertainment', 
        name: 'Entretenimiento premium', 
        baseCost: 7232, 
        category: 'entertainment', 
        input_type: 'custom_amount', 
        default_value: 7232 
      },
      { 
        id: 'vip-entertainment', 
        name: 'Estilo de vida VIP', 
        baseCost: 13560, 
        category: 'entertainment', 
        input_type: 'custom_amount', 
        default_value: 13560 
      }
    ]
  },
  {
    id: 'family',
    name: 'Familia',
    icon: 'Users',
    items: [
      { 
        id: 'children-expenses', 
        name: 'Gastos para niños (básicos, sin educación)', 
        baseCost: 4520, 
        category: 'family', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'family-activities', 
        name: 'Actividades familiares', 
        baseCost: 2712, 
        category: 'family', 
        input_type: 'custom_amount', 
        default_value: 2712 
      },
      { 
        id: 'elderly-care', 
        name: 'Cuidado de adultos mayores', 
        baseCost: 7232, 
        category: 'family', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'pets', 
        name: 'Mascotas (alimentación y veterinario)', 
        baseCost: 1808, 
        category: 'family', 
        input_type: 'quantity', 
        default_value: 1 
      }
    ]
  },
  {
    id: 'education',
    name: 'Educación',
    icon: 'GraduationCap',
    items: [
      { 
        id: 'public-education', 
        name: 'Educación pública (gastos complementarios)', 
        baseCost: 904, 
        category: 'education', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'standard-private', 
        name: 'Colegio privado estándar (por hijo)', 
        baseCost: 5424, 
        category: 'education', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'premium-private', 
        name: 'Colegio privado premium (por hijo)', 
        baseCost: 10848, 
        category: 'education', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'international-education', 
        name: 'Educación internacional (por hijo)', 
        baseCost: 22600, 
        category: 'education', 
        input_type: 'quantity', 
        default_value: 1 
      }
    ]
  },
  {
    id: 'health',
    name: 'Salud',
    icon: 'Stethoscope',
    items: [
      { 
        id: 'basic-insurance', 
        name: 'Seguro básico (por persona)', 
        baseCost: 1808, 
        category: 'health', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'complete-insurance', 
        name: 'Seguro completo (por persona)', 
        baseCost: 3616, 
        category: 'health', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'premium-insurance', 
        name: 'Seguro premium', 
        baseCost: 7232, 
        category: 'health', 
        input_type: 'quantity', 
        default_value: 1 
      },
      { 
        id: 'vip-insurance', 
        name: 'Seguro VIP (cobertura internacional)', 
        baseCost: 13560, 
        category: 'health', 
        input_type: 'quantity', 
        default_value: 1 
      }
    ]
  },
  {
    id: 'services',
    name: 'Servicios',
    icon: 'Wrench',
    items: [
      { 
        id: 'basic-services', 
        name: 'Servicios básicos (limpieza ocasional)', 
        baseCost: 1356, 
        category: 'services', 
        input_type: 'custom_amount', 
        default_value: 1356 
      },
      { 
        id: 'regular-services', 
        name: 'Servicios regulares (limpieza semanal)', 
        baseCost: 2712, 
        category: 'services', 
        input_type: 'custom_amount', 
        default_value: 2712 
      },
      { 
        id: 'partial-domestic', 
        name: 'Servicio doméstico parcial', 
        baseCost: 7232, 
        category: 'services', 
        input_type: 'custom_amount', 
        default_value: 7232 
      },
      { 
        id: 'full-domestic', 
        name: 'Servicio doméstico completo', 
        baseCost: 18080, 
        category: 'services', 
        input_type: 'custom_amount', 
        default_value: 18080 
      }
    ]
  },
  {
    id: 'travel',
    name: 'Viajes',
    icon: 'Plane',
    items: [
      { 
        id: 'occasional-travel', 
        name: 'Viajes ocasionales (nacionales)', 
        baseCost: 2712, 
        category: 'travel', 
        input_type: 'custom_amount', 
        default_value: 2712 
      },
      { 
        id: 'regular-travel', 
        name: 'Viajes regulares (internacionales)', 
        baseCost: 5424, 
        category: 'travel', 
        input_type: 'custom_amount', 
        default_value: 5424 
      },
      { 
        id: 'frequent-travel', 
        name: 'Viajes frecuentes (clase ejecutiva)', 
        baseCost: 10848, 
        category: 'travel', 
        input_type: 'custom_amount', 
        default_value: 10848 
      },
      { 
        id: 'luxury-travel', 
        name: 'Viajes de lujo (primera clase)', 
        baseCost: 22600, 
        category: 'travel', 
        input_type: 'custom_amount', 
        default_value: 22600 
      }
    ]
  }
];